module.exports = __webpack_public_path__ + "static/media/google-play-es.e4737383.svg";